

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import SecondLevelOptionComponent from '@/shared/components/twoLevelsSelector/secondLevelOption.view.vue';
import { SecondLevelOptionModel } from '@/shared/models/secondLevelOption.model';

@Component({
  components: {
    SecondLevelOptionComponent,
  },
})

export default class TwoLevelsSelector extends Vue {
  // PROPS
  @Prop({ default: false }) private disabled!: boolean;
  @Prop() private firstLevelOptions!: any[];
  @Prop() private firstLevelOptionInitialIndex!: number;

  // DATA
  private firstLevelOptionSelected: any = {};
  private firstLevelOptionSelectedIndex: number = -1;
  private firstLevelOptionHoveredIndex: number = -1;
  private firstLevelOptionLocked: boolean = true;

  // HOOK LIFECICLE
  private created() {
      const firstLevelOptionInitial = this.firstLevelOptions[ this.firstLevelOptionInitialIndex ];
      this.firstLevelOptionSelectedIndex = this.firstLevelOptionInitialIndex;
      this.firstLevelOptionSelected = Object.assign( {}, firstLevelOptionInitial );
  }

  // COMPUTED
  private get secondLevelOptions() {
    const firstLevelOptionSelectedOptions = this.firstLevelOptionSelected.options;
    while ( firstLevelOptionSelectedOptions.length < this.firstLevelOptions.length ) {
      const fakeOption = new SecondLevelOptionModel(
          'fake_' + new Date().getTime() + '__' + Math.floor((Math.random() * 1000000) + 1),
          '',
          false,
          '',
          true,
      );
      firstLevelOptionSelectedOptions.push( fakeOption );
    }
    return firstLevelOptionSelectedOptions;
  }

  // METHODS
  private checkOptionDisabled( option: any ) {
    return this.disabled || option.disabled;
  }

  private checkOptionSelected( option: any ) {
    return option.value === this.firstLevelOptionSelected.value;
  }

  private checkOptionBeforeSelected( index: number ) {
    return ( this.firstLevelOptionLocked && index + 1 === this.firstLevelOptionSelectedIndex );
  }

  private checkOptionAfterSelected( index: number ) {
    return ( this.firstLevelOptionLocked && index - 1 === this.firstLevelOptionSelectedIndex );
  }

  private checkOptionBeforeHovered( index: number ) {
    return ( this.firstLevelOptionLocked && index + 1 === this.firstLevelOptionHoveredIndex );
  }

  private checkOptionAfterHovered( index: number ) {
    return ( this.firstLevelOptionLocked && index - 1 === this.firstLevelOptionHoveredIndex );
  }

  private changeFirstLevelOptionSelected( option: any, index: number ) {
    if ( !this.disabled && !this.firstLevelOptionLocked ) {
      this.firstLevelOptionSelected = option;
      this.firstLevelOptionSelectedIndex = index;
    }
  }

  private handleMouseenter( option: any, index: number ) {
    if ( !this.disabled ) {
      if ( this.firstLevelOptionLocked ) {
        this.firstLevelOptionHoveredIndex = index;
      }
      this.changeFirstLevelOptionSelected( option, index );
    }
  }

  private handleClick( option: any, index: number ) {
    if ( !this.disabled ) {
      this.unlockFirstLevelOptionSelected();
      this.changeFirstLevelOptionSelected( option, index );
      this.lockFirstLevelOptionSelected();
    }
  }

  private lockFirstLevelOptionSelected() {
    if ( !this.disabled ) {
      this.firstLevelOptionLocked = true;
    }
  }

  private unlockFirstLevelOptionSelected() {
    if ( !this.disabled ) {
      this.firstLevelOptionLocked = false;
    }
  }

  private emitClick( option: any ) {
    if ( !this.disabled ) {
      this.$emit( 'input', option );
    }
  }
}
